"use client";

import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstateEmblem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="239821" id="runet-status-report-indice" className="bg-background text-foreground w-full py-24 flex flex-col items-center justify-center">
      <div ref={ref} className={`flex flex-col items-center justify-center gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="bg-[#050507] border border-white/10 shadow-2xl p-8 rounded-sm max-w-2xl w-full backdrop-blur-md">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-secondary animate-pulse" />
            <span className="font-mono text-xs text-secondary tracking-widest uppercase">System Terminal v4.0</span>
          </div>
          <p className="font-mono text-secondary text-lg leading-relaxed">
            <span className="text-white">[STATUS REPORT]</span> Ultimo Aggiornamento: Aprile 2026.
            <br />
            <span className="text-white">Patch Notes:</span> Monitoraggio YATI attivo.
            <span className="inline-block w-2 h-5 ml-1 bg-secondary animate-bounce align-middle" />
          </p>
        </div>

        <nav className="flex flex-col items-center gap-6">
          <div className="flex flex-wrap justify-center gap-8">
            {[{
            id: "01",
            label: "YATI vs Google",
            href: "#section-1"
          }, {
            id: "02",
            label: "Sovranità Digitale",
            href: "#section-2"
          }, {
            id: "03",
            label: "Architetture .RU",
            href: "#section-3"
          }, {
            id: "04",
            label: "Lead Gen B2B",
            href: "#section-4"
          }, {
            id: "05",
            label: "VKontakte Marketing",
            href: "#section-5"
          }].map(item => <Link key={item.id} to={item.href} className="group flex items-center gap-2 transition-all hover:opacity-80">
                <span className="font-mono text-primary text-sm font-bold">{item.id}</span>
                <span className="font-default text-white text-sm uppercase tracking-wider group-hover:text-secondary transition-colors">
                  {item.label}
                </span>
              </Link>)}
          </div>
          <Separator className="w-10 bg-primary/50" />
        </nav>
      </div>
    </section>;
}